import { Component, OnInit } from '@angular/core';
import { Item } from 'src/app/components/link/link.component';

@Component({
  selector: 'app-methods',
  templateUrl: './methods.component.html',
  styleUrls: ['./methods.component.scss']
})
export class MethodsComponent implements OnInit {

  methods: Item[] = [
    { title: 'Stochastic Modelling', image: 'Method-Stochastic-Modelling.png', route: 'methods/stochastic-modelling' },
    { title: 'Population Modelling', image: 'Method-Population-Modelling.png', route: 'methods/population-modelling' },
    { title: 'Spatial Modelling', image: 'Method-Spatial-Modelling.png', route: 'methods/spatial-modelling' },
    { title: 'Bayesian Inference', image: 'Method-Bayesian-Inference.png', route: 'methods/bayesian-inference' },
    { title: 'Reaction Diffusion Systems', image: 'Method-Reaction-Diffusion-System.png', route: 'methods/reaction-diffusion-systems' },
    { title: 'Data Visualisation', image: 'Method-Data-Visualisation.png', route: 'methods/data-visualisation' },
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
